// import React from 'react'
// import styled from "styled-components";
// import { literToKiloliter, capitalizeFirstLetter } from '../utils/utils';
// import { BiCoinStack } from "react-icons/bi";

// const Container = styled.div`
//   background: #fff;
//   border-radius: 20px;
//   margin: 1rem;
//   padding: 1rem;
//   box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
//   width: 100%;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   @media (min-width: 61.313em) {
//     width: 60%;
//     justify-content: space-between;
//   }
// `;
// const LineItems = styled.div`
//   margin: 0.8rem 0;
//   display: flex;
//   justify-content: space-between;
// `;

// const ValuleStyle = styled.span`
//   font-weight: bold;
// `;

// const TankDetails = ({ dimension }) => {
//   console.log(dimension);
//   return (
//     <Container>
//       <h5>Tank Details</h5>

//       <LineItems>
//         Tank Shape
//         <ValuleStyle>{capitalizeFirstLetter(dimension?.tank_shape ?? "")}</ValuleStyle>
//       </LineItems>
//       <hr />
//       <LineItems>
//         Tank Capacity
//         <ValuleStyle>{literToKiloliter(dimension?.tank_volume || 0)}</ValuleStyle>
//       </LineItems>

//     </Container>
//   )
// }

// export default TankDetails


// import React from "react";
// import styled from "styled-components";
// import { literToKiloliter, capitalizeFirstLetter } from "../utils/utils";
// import { BiCoinStack } from "react-icons/bi";

// const Container = styled.div`
//   background: #fff;
//   border-radius: 20px;
//   margin: 2rem;
//   padding: 1rem 1.2rem;
//   box-shadow: rgba(149, 157, 165, 0.15) 0px 6px 16px;
//   width: 90%;             /* Reduced width for small screens */
//   max-width: 280px;       /* Optional: limit maximum width */
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;

//   @media (min-width: 61em) {
//     width: 50%;           /* Smaller width on large screens */
//   }
// `;

// const Header = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   margin-bottom: 0.8rem;

//   h5 {
//     margin: 0;
//     font-size: 0.95rem;
//     font-weight: 600;
//   }
// `;

// const BoxWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.8rem;
//   width: 100%;
// `;

// const GrayBox = styled.div`
//   background: #f5f6f7;
//   border-radius: 10px;
//   padding: 0.7rem 1rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   border: 1px solid #e0e0e0;
//   transition: all 0.25s ease;

//   &:hover {
//     background: #eef2f6;
//     transform: translateY(-1px);
//     box-shadow: rgba(0, 64, 128, 0.12) 0px 3px 6px;
//   }
// `;

// const Label = styled.span`
//   color: #555;
//   font-weight: 500;
//   font-size: 0.9rem;
// `;

// const Value = styled.span`
//   font-weight: 600;
//   color: #004080;
//   font-size: 0.95rem;
// `;

// const TankDetails = ({ dimension }) => {
//   return (
//     <Container>
//       <Header>
//         <BiCoinStack size={22} color="#004080" />
//         <h5>Tank Details</h5>
//       </Header>

//       <BoxWrapper>
//         <GrayBox>
//           <Label>Tank Shape</Label>
//           <Value>{capitalizeFirstLetter(dimension?.tank_shape ?? "")}</Value>
//         </GrayBox>

//         <GrayBox>
//           <Label>Tank Capacity</Label>
//           <Value>{literToKiloliter(dimension?.tank_volume || 0)}</Value>
//         </GrayBox>
//       </BoxWrapper>
      
//     </Container>
//   );
// };

// export default TankDetails;

import React from "react";
import styled from "styled-components";
import { literToKiloliter, capitalizeFirstLetter } from "../utils/utils";
import { BiCoinStack } from "react-icons/bi";

const Container = styled.div`
  background: #fff;
  border-radius: 20px;
  margin: 2rem;
  padding: 1rem 1.2rem;
  box-shadow: rgba(149, 157, 165, 0.15) 0px 6px 16px;
  width: 90%;             /* Reduced width for small screens */
  max-width: 280px;       /* Optional: limit maximum width */
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 61em) {
    width: 50%;           /* Smaller width on large screens */
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.8rem;

  h5 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
  }
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;
`;

const GrayBox = styled.div`
  background: #f5f6f7;
  border-radius: 10px;
  padding: 0.7rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e0e0e0;
  transition: all 0.25s ease;

  &:hover {
    background: #eef2f6;
    transform: translateY(-1px);
    box-shadow: rgba(0, 64, 128, 0.12) 0px 3px 6px;
  }
`;

const Label = styled.span`
  color: #555;
  font-weight: 500;
  font-size: 0.9rem;
`;

const Value = styled.span`
  font-weight: 600;
  color: #004080;
  font-size: 0.95rem;
`;

const TankDetails = ({ dimension }) => {
  return (
    <Container>
      <BoxWrapper>
        <GrayBox>
          <Label>Tank Shape</Label>
          <Value>{capitalizeFirstLetter(dimension?.tank_shape ?? "")}</Value>
        </GrayBox>

        <GrayBox>
          <Label>Tank Capacity</Label>
          <Value>{literToKiloliter(dimension?.tank_volume || 0)}</Value>
        </GrayBox>
      </BoxWrapper>
      
    </Container>
  );
};

export default TankDetails;